<script>
    import DropdownButton from './DropdownButton.svelte';

    export let link = null;
    export let dropdownVisible = false;
    export let disabled = false;
    export let buttonClass = 'btn btn-primary no-box-shadow';

    let copied = false
    let linkInputElement;

    function copyLink() {
        if (linkInputElement instanceof HTMLInputElement) {
            linkInputElement.focus();
            linkInputElement.selectionStart = 0;
            linkInputElement.selectionEnd = linkInputElement.value.length;

            try {
                document.execCommand('copy');
            } catch (e) {

            }

            linkInputElement.blur();

            copied = true;
            setTimeout(() => copied = false, 2000);
        }
    }

    function dismiss() {
        dropdownVisible = false;
    }
</script>

<style>
    .joined-items {
        min-width: 30em;
        max-width: calc(100vw - 5em);
    }

    .joined-items .btn {
        min-width: 80px;
        text-align: center;
    }

    @media (max-width: 650px) {
        .joined-items {
            min-width: auto;
            max-width: none;
            display: block;
            text-align: center;
            margin-bottom: 0;
        }

        .joined-items > * {
            display: inline-block;
            border-radius: 0 !important;
            margin-bottom: 0.5em;
        }

        .joined-items > input {
            min-width: auto;
        }
    }
</style>

<DropdownButton title="Share report" bind:dropdownVisible {disabled}>
    <i slot="icon" class="icon icon-link"
       class:active={dropdownVisible}></i>

    <div slot="dropdownContent">
        <p>
            Share this link: {#if copied}link copied{/if}
        </p>
        <p class="joined-items d-flex">
                <input bind:this={linkInputElement}
                       bind:value={link}
                       class="form-control report-link"
                       type="text">
                <button class={buttonClass} on:click={copyLink}>Copy</button>
        </p>
    </div>
</DropdownButton>
